import React from 'react';
import ImpactTab from './DQProV2/components/LearnCreator/ImpactTab.comp';

const DQProInsights = () => <ImpactTab />;

export default DQProInsights;
